import { combineInvestmentTrans } from "../../components/moneyBuilder/investments/objects/combine_investment_trans";

export const investmentsGetCurrentPrice = (investmentMonthlyData, investmentMasterData, gameInvestments) => {
    let currentPriceArr = [];
    for (let i=0; i<investmentMonthlyData.length; i++){
        const monthlyData = investmentMonthlyData[i];
        const currentPriceObj = {investShortName: monthlyData.investShortName, currentPrice: monthlyData.closingPrice};
        currentPriceArr.push(currentPriceObj);
    }
    
    let investTranArr = [];
    for (let i=0; i<gameInvestments.length; i++){
        // eliminate any transactions that are not found on the investmentMaster
        for (let j=0; j<gameInvestments[i].transactionArr.length; j++){
            let transaction = gameInvestments[i].transactionArr[j];
            const shortName = transaction.investShortName;
            const investMasterObj = investmentMasterData.find(elem => elem.investShortName === shortName);
            if (investMasterObj){
                investTranArr.push(transaction);
            }
        }
    }
    let investmentMasterArr = [];
    let investTypeArr = [];
    for (let i=0; i<investmentMasterData.length; i++){
        const investShortName = investmentMasterData[i].investShortName;
        const currentPriceObj = currentPriceArr.find(elem => elem.investShortName === investShortName);
        let currentPrice = 0;
       
        if (currentPriceObj){
            currentPrice = currentPriceObj.currentPrice;
        }
        investmentMasterData[i] = {...investmentMasterData[i], currentPrice: currentPrice};
        const investMaster = investmentMasterData[i];
        if (!investTypeArr.includes(investMaster.investmentType)){
            investTypeArr.push(investMaster.investmentType);
        }
        const investMasterObj = {investShortName: investMaster.investShortName, investmentName: investMaster.investmentName,
                symbol: investMaster.symbol, imageUrl: investMaster.imageUrl, classification: investMaster.classification,
                investType: investMaster.investmentType }
        investmentMasterArr.push(investMasterObj);
    }
    let transactionDetailArr = [];
    let summaryBuyArr = [];
    let totalBuyArr = [];
    let updatedGameInvestments = [];
    for (let i=0; i<gameInvestments.length; i++){
        const investmentTransactionData = gameInvestments[i].transactionArr;
        const investType = gameInvestments[i].investType;
    //  the combined routine combines all transactions for the same stock into the same row
    //  it also eliminates any stocks if the current quantity for the stock is zero (due to sell trans)
        const beginHistoryTransNbr = gameInvestments[i].historyTranArr.length;
        const combinedTransactions = 
        combineInvestmentTrans(investmentTransactionData, currentPriceArr, investmentMasterArr,
                beginHistoryTransNbr );
        let buyTransArr = combinedTransactions.summaryBuyArr;
        const historyArr = combinedTransactions.historyArr;
        const updatedTransactionArr = combinedTransactions.updatedTransactionArr;
        totalBuyArr = combinedTransactions.totalBuyArr;
  
        // if there are no new entries in the historyArr, then no need to update gameInvestments
        // since there has been no change to the transactionArr
        if (historyArr.length > 0){
            let newHistoryArr = [];
            if (gameInvestments[i].historyTranArr){
                newHistoryArr = gameInvestments[i].historyTranArr.concat(historyArr);
            }else{
                newHistoryArr = historyArr;
            }
            const updatedGameInvestObj = {
                gameID: gameInvestments[i].gameID,  
                investType: investType,
                currentlyActive: gameInvestments[i].currentlyActive,
                dateAdded: gameInvestments[i].dateAdded,
                maturityDateArr: gameInvestments[i].maturityDateArr,
                transactionArr: updatedTransactionArr,
                historyTranArr: newHistoryArr,
                taxHistoryArr: gameInvestments[i].taxHistoryArr
            }
            updatedGameInvestments.push(updatedGameInvestObj);
        }
        for (let j=0; j<buyTransArr.length; j++){
            const transactionDetailObj = {investType: investType, ...buyTransArr[j]};
            transactionDetailArr.push(transactionDetailObj);
        }
        const totalBuyObj = {investType: investType, buyTransArr: combinedTransactions.summaryBuyArr};
        summaryBuyArr.push(totalBuyObj);
    }
    //  this ensures that summaryBuyArr has at least 1 entry for each investType
    for (let i=0; i<investTypeArr.length; i++){
        const investTypeObj = summaryBuyArr.find(elem => elem.investType === investTypeArr[i]);
        if (!investTypeObj){
            const summaryBuyObj = {investType: investTypeArr[i], buyTransArr: []}
            summaryBuyArr.push(summaryBuyObj);
        }
    }
    const returnObj = {transactionDetailArr: transactionDetailArr, summaryBuyArr: summaryBuyArr,
        totalBuyArr: totalBuyArr, updatedGameInvestments: updatedGameInvestments
    }
    return returnObj;
}


export default investmentsGetCurrentPrice;